module.exports = __webpack_public_path__ + "img/gh-30513-4.prt.0b005604.jpg";